import { AHText, Box, TouchableBox } from "arkh";

import { DayFilter, RoleFilter } from "./filter";
import { FormattedMessage } from "react-intl";

function FilteredEmptyState(props: { onClearFilters: () => void }) {
  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }} gap="xsmall">
      <AHText type="subtitle" color="text-secondary">
        <FormattedMessage
          defaultMessage="No routines match the filter."
          description="TeamScheduleAdmin daily filtered empty state"
        />
      </AHText>
      <TouchableBox
        onPress={props.onClearFilters}
        style={{ padding: 16, margin: -16 }}
      >
        <AHText type="subtitle" color="text-primary">
          <FormattedMessage
            defaultMessage="Clear filters"
            description="TeamScheduleAdmin clear filters button"
          />
        </AHText>
      </TouchableBox>
    </Box>
  );
}

export function TeamScheduleAdminListEmptyState(props: {
  mode: "daily" | "weekly" | "monthly";
  selectedDaysFilter: DayFilter;
  selectedRoleFilter: RoleFilter;
  onClearFilters: () => void;
}) {
  const hasDayFilter =
    props.mode === "daily" && props.selectedDaysFilter !== "all";
  const hasActiveFilter = hasDayFilter || props.selectedRoleFilter !== "all";

  if (hasActiveFilter) {
    return (
      <Box
        style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        spaceTop="xlarge"
      >
        <FilteredEmptyState onClearFilters={props.onClearFilters} />
      </Box>
    );
  }

  return (
    <Box
      style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
      spaceTop="xlarge"
    >
      <AHText type="subtitle" color="text-secondary">
        {props.mode === "daily" ? (
          <FormattedMessage
            defaultMessage="This team does not have any daily routines yet."
            description="TeamScheduleAdmin daily all empty state"
          />
        ) : props.mode === "weekly" ? (
          <FormattedMessage
            defaultMessage="This team does not have any weekly routines yet."
            description="TeamScheduleAdmin weekly empty state"
          />
        ) : (
          <FormattedMessage
            defaultMessage="This team does not have any monthly routines yet."
            description="TeamScheduleAdmin weekly empty state"
          />
        )}
      </AHText>
    </Box>
  );
}
